var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"logo-wrap"},[_c('div',{staticClass:"content"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("./../assets/logo.png"),"alt":""}})]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("免费发布信息")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145ac81f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishNav.vue
// module id = null
// module chunks = 